import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { MainLayout } from "./layouts/MainLayout";
import { useAppSelector } from "./store/store";
import { Home } from "./views/Home";
import { LoginTepngUser } from "./views/LoginTepngUser";
import { RoutePathNames } from "./helpers/Constants";
import { ViewVendors } from "./views/ViewVendors";
import { ViewVendorUsers } from "./views/ViewVendorsUsers";
import { ViewSupplementaryVendorEmailRequests } from "./views/ViewSupplementaryVendorEmailRequests";
import { ViewOnboardPendingVendors } from "./views/ViewOnboardPendingVendors";


interface ProtectedRouteProps {
  children: React.ReactNode
}

function ProtectedRoute({ children }: ProtectedRouteProps) {
  const loggedOnUserProfile = useAppSelector(state => state.loggedOnUserProfile.value);
  const location = useLocation();

  if (loggedOnUserProfile == null) {
    localStorage.setItem("loginRedirectedFromUrl", location.pathname + location.search);
    return <><Navigate to={"/" + RoutePathNames.LOGIN} replace /></>
  }
  else
    return <>{children}</>
}

function NoRouteMatch() {
  const location = useLocation();
  return (<div> <h3> No Route match for <code>{location.pathname}</code> </h3> </div>);
}


export function VendorOnboardingRoutes() {
  return (
    <Routes>
      <Route path="/" element={<ProtectedRoute><MainLayout header="Home Page" > <Home /> </MainLayout> </ProtectedRoute>} />
      <Route path={"/" + RoutePathNames.HOMEPAGE} element={<ProtectedRoute><MainLayout header="" > <Home /> </MainLayout> </ProtectedRoute>} />
      <Route path={"/" + RoutePathNames.LOGIN} element={<MainLayout header="" drawerHidden> <LoginTepngUser /> </MainLayout>} />
      <Route path={"/" + RoutePathNames.VENDORS} element={<ProtectedRoute><MainLayout header="Vendors" > <ViewVendors /> </MainLayout> </ProtectedRoute>} />
      <Route path={"/" + RoutePathNames.VENDOR_USERS} element={<ProtectedRoute><MainLayout header="Vendor Users" > <ViewVendorUsers /> </MainLayout> </ProtectedRoute>} />
      <Route path={"/" + RoutePathNames.SUPPLEMENTARY_VENDOR_EMAIL_REQUESTS} element={<ProtectedRoute><MainLayout header="Supplementary Vendor Email Requests" > <ViewSupplementaryVendorEmailRequests /> </MainLayout> </ProtectedRoute>} />
      <Route path={"/" + RoutePathNames.ONBOARD_PENDING_VENDORS} element={<ProtectedRoute><MainLayout header="Onboard Pending Vendors" > <ViewOnboardPendingVendors /> </MainLayout> </ProtectedRoute>} />
      <Route path="*" element={<MainLayout header="" drawerHidden> <NoRouteMatch /> </MainLayout>} />
    </Routes>
  );
}